import { Component, Input } from '@angular/core';

@Component({
  selector: 'wm-receipt-button',
  template: `
    <a [href]="receiptUrl"
       class="btn btn-raised btn-sm float-right receipt-btn"
       target="_blank"
       rel="noopener">
       View receipt
    </a>
  `,
   styles: [`
    .receipt-btn {
      background-color: #2f80ed;
      color: #fff;
      border: none;
      border-radius: 6px;
      padding: 6px 14px;
      font-size: 13px;
      font-weight: 600;
      box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    }

    .receipt-btn:hover {
      background-color: #1c6ed5;
    }
  `],
  standalone: false
})
export class ReceiptButtonComponent {
  @Input() pmtId: string | number;
  @Input() apiBase: string;

  get receiptUrl(): string {
    return `${this.apiBase}/files/receipt/${this.pmtId}`;
  }
}